import { usePublishingContext } from "../../../contexts/PublishingContext.js";
import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import React, { useEffect } from "react";
import { useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { DataZoomComponent, GridComponent, LegendComponent, TitleComponent, ToolboxComponent, TooltipComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { UniversalTransition } from "echarts/features";
//#region src/modules/Stats/shared/EventTypesStackedBarChart.tsx
echarts.use([
	DataZoomComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	GridComponent,
	LegendComponent,
	BarChart,
	CanvasRenderer,
	UniversalTransition
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function EventTypesStackedBarChart({ eventsHistogram }) {
	const { isDarkMode } = useAtalayaContext();
	const isPublishing = usePublishingContext()?.isPublishing;
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current || !eventsHistogram) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const eventTypes = /* @__PURE__ */ new Map();
		const dates = eventsHistogram.map((date, i) => {
			date.eventTypes.forEach((eventType) => {
				const eventTypeData = eventTypes.get(eventType.name) || {
					color: eventType.color,
					data: new Array(eventsHistogram.length).fill(0),
					name: eventType.name
				};
				eventTypeData.data[i] = eventType.count;
				eventTypes.set(eventType.name, eventTypeData);
			});
			return date.formattedDate;
		});
		const eventTypesSeriesData = Array.from(eventTypes.values()).map((eventType) => ({
			color: eventType.color,
			data: eventType.data,
			name: eventType.name,
			stack: "eventType",
			type: "bar"
		}));
		const option = {
			grid: { top: 110 },
			legend: {
				data: eventTypesSeriesData.map((eventType) => eventType.name),
				top: 50
			},
			series: eventTypesSeriesData,
			title: {
				left: "center",
				subtext: "Overall height of the bar represents day total",
				subtextStyle: { lineHeight: 4 },
				text: "Event Types Per Day"
			},
			xAxis: {
				data: dates,
				type: "category"
			},
			yAxis: { type: "value" }
		};
		if (!isPublishing) {
			option.tooltip = { trigger: "axis" };
			option.dataZoom = [{
				end: 100,
				start: 0,
				type: "inside"
			}, {
				end: 100,
				start: 0
			}];
			option.toolbox = { feature: {
				dataZoom: {},
				restore: {},
				saveAsImage: {}
			} };
		}
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		eventsHistogram,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: {
			height: 500,
			width: "100%"
		}
	});
}
//#endregion
export { EventTypesStackedBarChart };

//# sourceMappingURL=EventTypesStackedBarChart.js.map